module.exports = __webpack_public_path__ + "static/media/plus.1e71bac7.svg";